module.exports = __webpack_public_path__ + "static/major-ecommerce-platforms-5ab86cb071dc429f3f4cd4a173a1c611.png";